// extracted by mini-css-extract-plugin
export default {"popup__error":"Error_popup__error__PydT+"};